/**
 * Hybrid EmptyState Component
 * Automatically chooses between Tailwind and styled-components based on props.
 *
 * Routes to the styled-components path when a styled-system prop is present
 * (hasStyledProps) or the component was extended with styled()
 * (isStyledExtension). Otherwise renders the Tailwind path.
 *
 * No mixin check is needed: EmptyState's root applies no standalone mixin
 * beyond the styled-system set, so hasStyledProps covers every routing prop.
 */

import React from "react";
import {
  hasStyledProps,
  isStyledExtension,
} from "@sproutsocial/seeds-react-system-props";

import type { TypeEmptyStateProps } from "./EmptyStateTypes";
import EmptyStateStyled from "./EmptyStateStyled"; // Styled-components version
import { EmptyStateTailwind } from "./EmptyStateTailwind"; // Tailwind version

const EmptyStateHybrid = React.forwardRef<HTMLDivElement, TypeEmptyStateProps>(
  (props, ref) => {
    if (hasStyledProps(props) || isStyledExtension(props)) {
      return <EmptyStateStyled {...props} ref={ref} />;
    }

    // Use Tailwind version (preferred - better performance)
    return <EmptyStateTailwind {...props} ref={ref} />;
  }
);

EmptyStateHybrid.displayName = "EmptyState";
export default EmptyStateHybrid;
